import React from 'react';
import Icon from '../../../components/AppIcon';

export const RecentActivity = ({ activities, userRole }) => {
  if (!activities?.length) {
    return (
      <div className="text-center py-8">
        <Icon name="Activity" size={32} className="text-blue-200 opacity-50 mx-auto mb-3" />
        <p className="text-blue-200 text-sm">No recent activity to display.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities?.map((activity) => (
        <div key={activity?.id} className="flex items-start space-x-3 p-3 bg-white bg-opacity-5 rounded-lg hover:bg-opacity-10 transition-all duration-200">
          <div className="p-2 bg-white bg-opacity-10 rounded-lg">
            <Icon name={activity?.icon || 'Info'} size={16} className="text-blue-100" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-white font-medium text-sm">
              {activity?.title}
            </h4>
            <p className="text-blue-200 text-sm opacity-80 mt-1">
              {activity?.description}
            </p>
            <p className="text-blue-300 text-xs opacity-60 mt-2">
              {activity?.time}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};